module.exports = __webpack_public_path__ + "img/banner_nv1.ed16a49c.webp";